import { Box, Text } from '@factorialco/deprecated-design-system'
import { NodeProps } from '@xyflow/react'

import { type CustomLevelNode } from 'modules/job_catalog/components/DevJobCatalogTree/types'

const JobCatalogLevelNode = (props: NodeProps<CustomLevelNode>) => {
  return (
    <Box
      borderRadius={{ all: 'abs100' }}
      padding="s8"
      paddingX="s12"
      style={{ cursor: 'pointer' }}
      border={{
        all: {
          color: props.selected ? 'viridian800' : 'grey100',
          style: 'solid',
          width: 's2',
        },
      }}
    >
      <Text size="200" weight={props.selected ? 'semibold' : 'normal'}>
        {props.data.name}
      </Text>
    </Box>
  )
}

export default JobCatalogLevelNode
